import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { SelectorDialogData } from '../selector-dialog/selector-dialog.component';
import { FormsModule } from '@angular/forms';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-checkbox-selector-dialog',
  templateUrl: './checkbox-selector-dialog.component.html',
  styleUrl: './checkbox-selector-dialog.component.css',
  standalone: true,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatCheckbox, MatDialogActions, MatButton, FormsModule],
})
export class CheckboxSelectorDialogComponent implements OnInit {
  dialog_ref = inject<MatDialogRef<CheckboxSelectorDialogComponent>>(MatDialogRef);
  data = inject<SelectorDialogData>(MAT_DIALOG_DATA);

  selected_values: unknown[] = [];

  ngOnInit(): void {
    if (this.data.initial_selected_values?.length) {
      this.selected_values = [...this.data.initial_selected_values];
    }
  }

  toggleSelection(value: unknown): void {
    const index = this.selected_values.indexOf(value);
    if (index >= 0) {
      this.selected_values.splice(index, 1);
    } else {
      this.selected_values.push(value);
    }
  }

  isSelected(value: unknown): boolean {
    return this.selected_values.includes(value);
  }

  submit(): void {
    this.dialog_ref.close(this.selected_values);
  }
}
